import { CSSProperties, FC, memo, ReactNode } from "react";
import CheckBlogItem from "./CheckBlogItem";

const commonStyles: CSSProperties = {
  position: "absolute",
  height: "208px",
  width: "300px",
};

const previewStyles: CSSProperties = {
  ...commonStyles,
  zIndex: 100,
};

const previewStyles2: CSSProperties = {
  ...commonStyles,
  zIndex: 99,
  top: "6px",
  left: "-7px",
};

const previewStyles3: CSSProperties = {
  ...commonStyles,
  zIndex: 98,
  top: "12px",
  left: "-14px",
};

export interface BoxProps {
  preview?: boolean;
  blogItem?: any;
  isBeingDragged?: boolean;
  isDraggable?: boolean;
  boxNumber?: number;
  count?: number;
  children?: ReactNode;
}

export const Box: FC<BoxProps> = memo(function Box(props) {
  const { preview, isBeingDragged, isDraggable, boxNumber, count, children } = props;
  const cursor = isDraggable ? "move" : "default";
  let title, is_curated, id, image_url, publish_date, website;
  if (props.blogItem) {
    ({ title, is_curated, id, image_url, publish_date, website } = props.blogItem);
  }

  let styles = boxNumber === 2 ? previewStyles2 : boxNumber === 3 ? previewStyles3 : previewStyles;
  const img =
    "https://imagedev.xiq.io//returnimage/?url=&width=95&height=95&articleid=357955971&detectface=true&app_name=wb";
  return (
    <div
      style={preview ? { ...styles } : { cursor }}
      role={preview ? "BoxPreview" : "Box"}
      draggable={isDraggable}
    >
      {preview ? (
        <CheckBlogItem
          articleId={id}
          title={title}
          imgUrl={image_url || img}
          publishDate={publish_date}
          isCurated={is_curated}
          isBeingDragged={isBeingDragged}
          isChecked={isDraggable}
          isDraggable={isDraggable}
          preview={preview}
          count={count}
          website={website}
        />
      ) : (
        children
      )}
    </div>
  );
});
